import { User_Role } from '@occc/graphql';

import { AccessControlMatrix, useAccessControlContext, UserScopedRole } from '.';
import { Feature } from './types';

export function isUserPermittedTo(
  role: User_Role,
  scopedRole: UserScopedRole,
  feature: Feature,
  matrix: AccessControlMatrix,
): boolean {
  const accessControlMatrixFiltered = matrix.find((value) => {
    const [userRole, userScopedRole] = value;

    if (userRole !== role) {
      return false;
    }

    if (userScopedRole && scopedRole !== userScopedRole) {
      return false;
    }

    return true;
  });

  const availableFeatures = accessControlMatrixFiltered?.[2];

  if (!availableFeatures) {
    // TODO: do we want to log it somehow?
    return false;
  }

  return availableFeatures.includes(feature);
}

export const useIsUserPermittedTo = (feature: Feature): boolean => {
  const value = useAccessControlContext();

  return value
    ? isUserPermittedTo(value.userRole, value.userScopedRole, feature, value.accessControlMatrix)
    : false;
};

export const useGetIsUserPermittedTo = () => {
  const value = useAccessControlContext();

  return (feature: Feature) =>
    value
      ? isUserPermittedTo(value.userRole, value.userScopedRole, feature, value.accessControlMatrix)
      : false;
};
